<h2 mat-dialog-title>Porta un amico!</h2>

<mat-dialog-content>
  <p class="text-muted small">
    Inserisci qui i suoi dati. Penseremo noi a contattarlo e ad attivare il suo account!
  </p>

  <div class="container-fluid p-0">
    <!-- Loading Spinner -->
    <div *ngIf="isLoading" class="d-flex justify-content-center align-items-center py-4">
      <mat-spinner diameter="50"></mat-spinner>
    </div>

    <!-- Form: .izy-fields (utility globale) da' ai campi il contorno nero 2px
         e il raggio 16px del linguaggio BEIZY, come nel resto dell'app. -->
    <form [formGroup]="referralForm" *ngIf="!isLoading" class="izy-fields mt-3">
      <!-- Name Field -->
      <mat-form-field appearance="outline" class="w-100 mb-2">
        <mat-label>Nome e Cognome</mat-label>
        <input
          matInput
          formControlName="name"
          placeholder="Inserisci nome e cognome">
        <mat-icon matSuffix class="field-suffix-icon">person</mat-icon>
        <mat-error *ngIf="isFieldInvalid('name')">
          {{ getErrorMessage('name') }}
        </mat-error>
      </mat-form-field>

      <!-- Email Field -->
      <mat-form-field appearance="outline" class="w-100 mb-2">
        <mat-label>Email</mat-label>
        <input
          matInput
          formControlName="mail"
          placeholder="Inserisci email"
          type="email">
        <mat-icon matSuffix class="field-suffix-icon">email</mat-icon>
        <mat-error *ngIf="isFieldInvalid('mail')">
          {{ getErrorMessage('mail') }}
        </mat-error>
      </mat-form-field>

      <!-- Telephone Field -->
      <mat-form-field appearance="outline" class="w-100 mb-2">
        <mat-label>Telefono</mat-label>
        <input
          matInput
          formControlName="telephone"
          placeholder="Inserisci telefono"
          type="tel">
        <mat-icon matSuffix class="field-suffix-icon">phone</mat-icon>
        <mat-error *ngIf="isFieldInvalid('telephone')">
          {{ getErrorMessage('telephone') }}
        </mat-error>
      </mat-form-field>

      <!-- Già Partita IVA -->
      <div class="row align-items-center mb-3">
        <div class="col-12 d-flex align-items-center">
          <mat-checkbox formControlName="is_already_partita_iva" color="primary">
            È già una Partita IVA
          </mat-checkbox>
          <mat-icon
            class="ms-2 info-hint-icon"
            matTooltip="Seleziona se la persona ha già una Partita IVA"
            [matTooltipPosition]="'right'"
            [matTooltipShowDelay]="showDelay.value || 700">
            info
          </mat-icon>
        </div>
      </div>

      <!-- Consenso privacy: riquadro a se', cosi' la spunta obbligatoria non
           si confonde con i campi del form. -->
      <div class="privacy-box izy-sharp-bl">
        <mat-checkbox
          formControlName="privacy_1"
          color="primary"
          [class.text-danger]="isFieldInvalid('privacy_1')">
          <span class="fw-bold">Acconsento al trattamento dei dati personali della persona da me presentata, e dichiaro di aver ricevuto il suo consenso per l'invio dei dati *</span>
        </mat-checkbox>
        <mat-error *ngIf="isFieldInvalid('privacy_1')" class="small">
          Devi accettare il trattamento dei dati per procedere
        </mat-error>
        <small class="text-muted d-block mt-1">
          I dati saranno utilizzati esclusivamente per la gestione della richiesta e per la corretta creazione dell'account.
        </small>
      </div>
    </form>
  </div>
</mat-dialog-content>

<!-- Barra delle azioni: fondo panna separato dal contenuto dal tratto nero
     2px, come il footer delle card e dei dialog di conferma. -->
<mat-dialog-actions align="end" class="izy-dialog-actions">
  <button
    mat-stroked-button
    type="button"
    (click)="onCancel()"
    [disabled]="isLoading"
    class="izy-button-ghost custom-button-border">
    <mat-icon>close</mat-icon>
    Annulla
  </button>

  <button
    mat-raised-button
    matButton="filled"
    type="button"
    (click)="createReferralRequest()"
    [disabled]="isLoading || referralForm.invalid"
    class="ms-2 izy-button-primary custom-button-border">
    <mat-icon *ngIf="!isLoading">send</mat-icon>
    <mat-spinner *ngIf="isLoading" diameter="20" class="d-inline-block me-2"></mat-spinner>
    {{ isLoading ? 'Invio in corso...' : 'Invia Richiesta' }}
  </button>
</mat-dialog-actions>
